// import Swiper JS
import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';


export default function initializeSwiperGallery() {

    let gallery = undefined;
    function initSwiper() {
        let screenWidth = window.innerWidth;
        if(screenWidth <= 992.98 && gallery == undefined) {
            gallery = new Swiper('.gallery-swiper', {
                modules: [Navigation, Pagination],
                slidesPerView: 'auto',
                centeredSlides: true,
                preloadImages: true,
                loop:true,
                spaceBetween: 30,
                pagination: {
                    el: ".swiper-pagination-gallery",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next-gallery",
                    prevEl: ".swiper-button-prev-gallery",
                },
            });
        } else if (screenWidth > 991 && gallery != undefined) {
            gallery.destroy();
            gallery = undefined;
            $('.swiper-wrapper').removeAttr('style');
            $('.swiper-slide').removeAttr('style');
        }
    }
    //Swiper plugin initialization
        initSwiper();

    //Swiper plugin initialization on window resize
        $(window).on('resize', function(){
            initSwiper();
        })


    let currentImageGallery = parseInt($("#current-image").text());
    $(".image-swiper-slide").click(function (e) {
        if ($(".gallery-photo-viewer").find(".view-image").length >= 1)
        {
            $(".gallery-photo-viewer").find(".view-image").remove();

        }
        let currentImageNumber = $("#current-image");
        currentImageNumber.text($(this).attr("id"))
        let imageElement = document.createElement("img");
        imageElement.setAttribute("src", $(this).attr("src"));
        imageElement.setAttribute("alt", $(this).attr("alt"));
        imageElement.setAttribute("class", "view-image");
        $(".gallery-photo-viewer").append(imageElement);
        $(".gallery-photo-viewer img").animate({
            opacity: 1,
        }, 100, function() {
        });
        $(".swiper-item-link-active").removeClass("show-bar");
        $(this).prev().addClass("show-bar");
        currentImageGallery = parseInt($("#current-image").text())
    });

    $("#arrow-right").click(function (e) {
        let currentImageId = null;
        if(currentImageGallery == $(".swiper-slide.swiper-slide-image").length) {
            currentImageGallery  = 1;
            currentImageId = "#"+currentImageGallery;
        }
        else {
            currentImageGallery  = currentImageGallery  + 1;
            currentImageId = "#"+currentImageGallery;
        }
        if ($(".gallery-photo-viewer").find(".view-image").length >= 1)
        {
            $(".gallery-photo-viewer").find(".view-image").remove();

        }
        $("#current-image").text(""+currentImageGallery+"");
        let currentImageNumber = $(""+currentImageId+"");
        let imageElement = document.createElement("img");
        imageElement.setAttribute("src", currentImageNumber.attr("src"));
        imageElement.setAttribute("alt", currentImageNumber.attr("alt"));
        imageElement.setAttribute("class", "view-image");
        $(".gallery-photo-viewer").append(imageElement);
        $(".gallery-photo-viewer img").animate({
            opacity: 1,
        }, 100, function() {
        });
        $(".swiper-item-link-active").removeClass("show-bar");
        currentImageNumber.prev().addClass("show-bar");

    });

    $("#arrow-left").click(function (e) {
        let currentImageId = null;
        if(currentImageGallery == 1) {
            currentImageGallery  = $(".swiper-slide.swiper-slide-image").length;
            currentImageId = "#"+currentImageGallery;
        }
        else {
            currentImageGallery  = currentImageGallery  - 1;
            currentImageId = "#"+currentImageGallery;
        }
        if ($(".gallery-photo-viewer").find(".view-image").length >= 1)
        {
            $(".gallery-photo-viewer").find(".view-image").remove();

        }
        $("#current-image").text(""+currentImageGallery+"");
        let currentImageNumber = $(""+currentImageId+"");
        let imageElement = document.createElement("img");
        imageElement.setAttribute("src", currentImageNumber.attr("src"));
        imageElement.setAttribute("alt", currentImageNumber.attr("alt"));
        imageElement.setAttribute("class", "view-image");
        $(".gallery-photo-viewer").append(imageElement);
        $(".gallery-photo-viewer img").animate({
            opacity: 1,
        }, 100, function() {
        });
        $(".swiper-item-link-active").removeClass("show-bar");
        currentImageNumber.prev().addClass("show-bar");
    });


}